const MOIS = [
  'janvier',
  'février',
  'mars',
  'avril',
  'mai',
  'juin',
  'juillet',
  'août',
  'septembre',
  'octobre',
  'novembre',
  'décembre',
] as const;

const deuxChiffres = (valeur: number): string => String(valeur).padStart(2, '0');

/** Calendar day of a date in the local time zone, as a day number (so a difference is a number of days). */
const numeroDeJour = (date: Date): number =>
  Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()) / 86_400_000;

/**
 * The date of a card of the history, in the local time of the browser:
 * "aujourd'hui, 10:42", "hier, 17:30", then "24 septembre", with the year when it is not
 * the current one ("24 septembre 2025"). The first of the month is "1er".
 *
 * `maintenant` is injectable so a test does not depend on the day it runs.
 */
export function formaterDate(creeLe: string, maintenant: Date = new Date()): string {
  const date = new Date(creeLe);
  const ecartEnJours = numeroDeJour(maintenant) - numeroDeJour(date);
  const heure = `${deuxChiffres(date.getHours())}:${deuxChiffres(date.getMinutes())}`;

  if (ecartEnJours === 0) return `aujourd'hui, ${heure}`;
  if (ecartEnJours === 1) return `hier, ${heure}`;

  const jour = date.getDate() === 1 ? '1er' : String(date.getDate());
  const complet = `${jour} ${MOIS[date.getMonth()]}`;
  return date.getFullYear() === maintenant.getFullYear()
    ? complet
    : `${complet} ${date.getFullYear()}`;
}
